import classNames from 'classnames';
import Done from '@material-ui/icons/Done';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/views/password/passwordFormStyles';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IRuleProps {
	name: string;
	success?: boolean;
	showErrors: boolean;
}

const Rule = ({ name, success, showErrors }: IRuleProps) => {
	const classes = useStyles();

	const ruleClasses = classNames({
		[classes.rule]: true,
		[classes.ruleSuccess]: success,
		[classes.ruleError]: showErrors && !success,
	});

	return (
		<div className={ruleClasses}>
			<Done />
			{name}
		</div>
	);
};

export default Rule;
